var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.isShowAd ? _c('div', {
    staticClass: "ad-space"
  }, [_c('billing-comp', {
    class: ['ad-wrap', {
      'ad-wrap-close': _vm.isClose
    }],
    attrs: {
      "card-info": _vm.cardInfo,
      "ad-info": _vm.adInfo,
      "ad-core-utils": _vm.adCoreUtils
    },
    nativeOn: {
      "animationend": function ($event) {
        return _vm.handleAnimationEnd.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "ad-container"
  }, [_c('div', {
    staticClass: "ad-image"
  }, [_vm.isVerticalImage ? _c('div', {
    staticClass: "ad-image-vertical"
  }, [_c('div', {
    staticClass: "blur-bg",
    style: {
      backgroundImage: `url(${_vm.adInfo.img_url})`
    }
  }), _c('div', {
    staticClass: "vertical-bg"
  }, [_c('div', {
    staticClass: "left-side"
  }), _c('img', {
    staticClass: "center-image",
    attrs: {
      "src": _vm.adInfo.img_url
    }
  }), _c('div', {
    staticClass: "right-side"
  })])]) : _c('img', {
    staticClass: "ad-image-horizontal",
    attrs: {
      "src": _vm.adInfo.img_url
    }
  }), _c('div', {
    staticClass: "ad-top-mark"
  }, [_c('div', {
    staticClass: "ad-tag"
  }), !_vm.adInfo.title ? _c('div', {
    staticClass: "ad-close",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.closeAd.apply(null, arguments);
      }
    }
  }) : _vm._e()])]), _vm.adInfo.title ? _c('div', {
    staticClass: "ad-desc"
  }, [_vm.adInfo.icon_url ? _c('img', {
    staticClass: "ad-desc-icon",
    attrs: {
      "src": _vm.adInfo.icon_url
    }
  }) : _vm._e(), _c('div', {
    class: ['ad-desc-content', {
      'content-left': _vm.adInfo.icon_url
    }]
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.textOmit(_vm.adInfo.title, 12)))]), _vm.adInfo.subtitle ? _c('div', {
    staticClass: "desc"
  }, [_vm._v(_vm._s(_vm.textOmit(_vm.adInfo.subtitle, 15)))]) : _vm._e()]), _c('div', {
    staticClass: "ad-desc-btn"
  }, [_vm._v(_vm._s(_vm.adJumpText))]), _c('div', {
    staticClass: "ad-desc-close",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.closeAd.apply(null, arguments);
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "ad-bottom-line"
  })])])], 1) : _vm._e();
};
var staticRenderFns = [];
export { render, staticRenderFns };